import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchSizeMasters(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchSizeMasters',
    () => source.cancel('fetchSizeMasters: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'size_masters',
      method: 'get',
      params,
      CancelToken: source.token,
      arrayFormat: 'brackets'
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      sizeMasters: _.get(data, 'sizeMasters', {}),
      pagination: _.get(data, 'sizeMastersPagination', {}),
      next: _.get(data, 'sizeMastersPagination.nextPage') > page
        ? () => fetchSizeMasters({
          page: page + 1,
          ...others
        })
        : null,
      count: _.get(data, 'sizeMastersPagination.totalCount')
    }))
}
